// removed by extract-text-webpack-plugin
module.exports = {"loader":"cms__Loader__loader","text":"cms__Loader__text","active":"cms__Loader__active","disabled":"cms__Loader__disabled","animateItem":"cms__Loader__animateItem","enter":"cms__Loader__enter","enterActive":"cms__Loader__enterActive","leave":"cms__Loader__leave","leaveActive":"cms__Loader__leaveActive"};


//////////////////
// WEBPACK FOOTER
// ./components/UI/loader/Loader.css
// module id = 553
// module chunks = 0